const strings = {
  tableHeader: {
    initials: 'Sigla',
    responsibleCTV: 'Ctv Responsável',
    counties: 'Munícipios',
  },
}
export default strings
